export interface ITablelistActionConfig {
  disabled: Array<string>;
  enabled?: Array<string>;
  labels: string;
}
